import styled from "styled-components";
import styles from "../../../Styles";

export const Container = styled.div`
  font-size: ${styles.typography.font.extraSmall};
  justify-content: space-between;

  border: 1.22px solid rgba(219, 230, 255, 1);
  background: #2E62AC;
  
  border-radius: 16px;
    height: auto;
    gap: 0px;
    border-radius: 27px;
    opacity: 0px;

  
`;
